import awards from "../../shared/la.awards";
import branded_quotes from "../../shared/la.branded-quotes";
import verticals from "./la-enterprise.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "la-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-enterprise-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contacto | Rosetta Stone",
                    meta_description:
                        "Los servicios profesionales globales y las empresas de consultoría se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación en idiomas ayudan a las firmas de consultoría profesionales a maximizar las horas facturables por empleado, lo que demuestra un retorno de la inversión significativo en la capacitación en idiomas en toda la organización.",
                    canonical_url: "https://espanol.rosettastone.com/empresa/contacto/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-enterprise-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-enterprise-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-enterprise-home":
            return {
                page,
                helmet: {
                    meta_title: "Capacitación Lingüística Empresarial | Rosetta Stone",
                    meta_description:
                        "Las soluciones de capacitación lingüística de Rosetta Stone ayudan a los empleados a desarrollar una competencia lingüística empresarial en el idioma inglés y en muchos otros idiomas de alta demanda. Solicite precios.",
                    canonical_url: "https://espanol.rosettastone.com/empresa/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-enterprise-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Capacitación Global Lingüística Empresarial | Rosetta Stone Catalyst",
                    meta_description:
                        "La capacitación global lingüística empresarial de Rosetta Stone Catalyst ofrece los idiomas empresariales más utilizados que los empleados pueden aprender desde cualquier lugar.  Solicite nuestros precios corporativos.",
                    canonical_url: "https://espanol.rosettastone.com/empresa/soluciones/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
